// ----------------------------------------------------------------------


function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_CONFERENCE = '/conference';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),

  // eventForm:  (eventid, year) => path(ROOTS_DASHBOARD, `/vendorpreconventionform/${eventid}/${year}`),

  // eventPostForm:  (eventid, year) => path(ROOTS_DASHBOARD, `/vendorpostconventionform/${eventid}/${year}`),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_CONFERENCE_MANAGEMENT = {
  root: ROOTS_CONFERENCE,
  conference: {
    root: path(ROOTS_CONFERENCE, '/conference-event-management/conference-event'),
    form: path(ROOTS_CONFERENCE, '/conference-event-management/form'),
  },
  journal: {
    root: path(ROOTS_CONFERENCE, '/journal-management'),
  },
  survey: {
    root: path(ROOTS_CONFERENCE, '/survey-management'),
    form: path(ROOTS_CONFERENCE, '/survey-management/form'),
  },
  setting: {
    root: path(ROOTS_CONFERENCE, '/settings'),
  },
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  fileManager: path(ROOTS_DASHBOARD, '/files-manager'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    maindashboard: path(ROOTS_DASHBOARD, '/maindashboard'), // Main dashboard path
    meitdDashboard: path(ROOTS_DASHBOARD, '/meitd-dashboard'),
    talentIntelligence: path(ROOTS_DASHBOARD, '/talent-intelligence'),
    talentSector: path(ROOTS_DASHBOARD, '/talent-sector'),
    talentForecast: path(ROOTS_DASHBOARD, '/talent-forecast'),
    pcdsImpact: path(ROOTS_DASHBOARD, '/pcds-2030'),
    prediction: path(ROOTS_DASHBOARD, '/prediction'),
    talentAnalytics: path(ROOTS_DASHBOARD, '/talent-analytics'),
    skillsGap: path(ROOTS_DASHBOARD, '/skills-gap'),
    aiLabourPrediction: path(ROOTS_DASHBOARD, '/ai-labour-prediction'),
    meitdAiAssistant: path(ROOTS_DASHBOARD, '/meitd-ai-assistant'),
    flightdashboard: path(ROOTS_DASHBOARD, '/flightdashboard'),
    PDFDetail: path(ROOTS_DASHBOARD, '/PDFDetail'),
    view: (id) => path(ROOTS_DASHBOARD, `/event/${id}`),
    events: path(ROOTS_DASHBOARD, '/events'),
    file: path(ROOTS_DASHBOARD, '/file'),
    goals: path(ROOTS_DASHBOARD, '/goals'),
    sdgChart: path(ROOTS_DASHBOARD, '/sdgChart'),
    list: (selectedID) => path(ROOTS_DASHBOARD, `/goals/list/${selectedID}`),
    inventory: path(ROOTS_DASHBOARD, '/inventory'),
    eventForm: path(ROOTS_DASHBOARD, `/eventForm`),
    survey: path(ROOTS_DASHBOARD, '/conference-event-management/conference-event'),

    eventPreForm: (eventid, year) =>
      path(ROOTS_DASHBOARD, `/vendorpreconventionform/${eventid}/${year}`),
    eventPostForm: (eventid, year) =>
      path(ROOTS_DASHBOARD, `/vendorpostconventionform/${eventid}/${year}`),

    eventInProcess: path(ROOTS_DASHBOARD, '/eventInProcess'),
    eventOrganizer: path(ROOTS_DASHBOARD, '/eventOrganizer'),
    organizationDashboard: path(ROOTS_DASHBOARD, '/organizationDashboard'),
    OrganizerKFADashboardPage: path(ROOTS_DASHBOARD, '/OrganizerKFADashboardPage'),
    OrganizerUNSDGDashboardPage: path(ROOTS_DASHBOARD, '/OrganizerUNSDGDashboardPage'),
    OrganizerCaseStudiesPage: path(ROOTS_DASHBOARD, '/OrganizerCaseStudiesPage'),
    OrganizerLegacyEventsPage: path(ROOTS_DASHBOARD, '/OrganizerLegacyEventsPage'),
    EventApplicationPage: path(ROOTS_DASHBOARD, '/EventApplicationPage'),

    event: {
      root: path(ROOTS_DASHBOARD, '/event-management'),
      PreForm: (selectedID) => path(ROOTS_DASHBOARD, `/Pre-form/${selectedID}`),
      CEForm: (selectedID) =>
        path(ROOTS_DASHBOARD, `/convention-and-exhibition-application-form/${selectedID}`),
      form1: path(ROOTS_DASHBOARD, '/convention-and-exhibition-application-form'),
      form: path(ROOTS_DASHBOARD, '/event-register-form'),
      report: path(ROOTS_DASHBOARD, '/event-report-form'),
      upload: path(ROOTS_DASHBOARD, '/upload-data'),
      questionnaire1: path(ROOTS_DASHBOARD, '/questionnairePage1'),
      questionnaire2: path(ROOTS_DASHBOARD, '/questionnairePage2'),
      questionnaire3: path(ROOTS_DASHBOARD, '/questionnairePage3'),
      questionnaire4: path(ROOTS_DASHBOARD, '/questionnairePage4'),
      questionnaire5: path(ROOTS_DASHBOARD, '/questionnairePage5'),
      questionnaire6: path(ROOTS_DASHBOARD, '/questionnairePage6'),
    },

    legacyImpactDashboard: {
      root: path(ROOTS_DASHBOARD, '/meitd-dashboard'),
      kfaDashboard: path(ROOTS_DASHBOARD, '/kfa-dashboard'),
      unsdgDashboard: path(ROOTS_DASHBOARD, '/unsdg-dashboard'),
      caseStudies: path(ROOTS_DASHBOARD, '/case-studies'),
      overall: path(ROOTS_DASHBOARD, '/overall'),
      legacyEvents: path(ROOTS_DASHBOARD, '/legacy-events'),
    },

    report: {
      root: path(ROOTS_DASHBOARD, '/report'),
      kfaReport: path(ROOTS_DASHBOARD, '/kfa-report'),
      unsdgReport: path(ROOTS_DASHBOARD, '/unsdg-report'),
      eventReport: path(ROOTS_DASHBOARD, '/event-report'),
    },

    legacyTraining: path(ROOTS_DASHBOARD, '/legacy-training'),
    legacyAward: path(ROOTS_DASHBOARD, '/legacy-award'),
    economicImpactIndex: path(ROOTS_DASHBOARD, '/economic-impact-index'),
  },
  bidBrief: {
    root: path(ROOTS_DASHBOARD, '/bidBrief'),
    list: path(ROOTS_DASHBOARD, '/bidBrief/list'),
    new: path(ROOTS_DASHBOARD, '/bidBrief/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/bidBrief/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/bidBrief/${id}/edit`),
  },
  mailTemplate: {
    root: path(ROOTS_DASHBOARD, '/mailTemplate'),
    list: path(ROOTS_DASHBOARD, '/mailTemplate/list'),
    edit: (id) => path(ROOTS_DASHBOARD, `/mailTemplate/${id}/edit`),
  },

  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = 'https://mui.com/store/items/minimal-dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';
